// jshint esversion: 6
// Append Expand to Parents
$('.off-canvas__menu .menu-item-has-children').append('<button aria-label="Expand menu" class="slider js-submenu-slider"><i class="fal fa-chevron-right"></i></button>');

// Expand/collapse on-click
$('.js-submenu-slider').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active').siblings('.sub-menu').finish().slideToggle();
})
